import {Center, Clickable, Icon} from 'platform/foundation';
import {css, useTheme} from 'styled-components';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {UserSidebarIconSize} from '@dms/api/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

interface DevSettingsHeaderButtonProps extends TestIdProps {
  isOpen: boolean;
  isAnyDevSettingEnabled: boolean;
  iconSize?: UserSidebarIconSize;
  onClick: () => void;
}

export function DevSettingsHeaderButton(props: DevSettingsHeaderButtonProps) {
  const theme = useTheme();

  const backgroundColor = match<[boolean, boolean], string>([
    props.isAnyDevSettingEnabled,
    props.isOpen,
  ])
    .with([false, false], always(theme.colors.palettes.yellow[30][100]))
    .with([false, true], always(theme.colors.palettes.yellow[50][100]))
    .with([true, false], always(theme.colors.palettes.red[30][100]))
    .with([true, true], always(theme.colors.palettes.red[40][100]))
    .exhaustive();

  return (
    <Clickable onClick={props.onClick}>
      <Center height={12}>
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: ${theme.getSize(8)};
            height: ${theme.getSize(8)};
            border-radius: ${theme.radii.small};
            background-color: ${backgroundColor};
            &:hover {
              filter: saturate(3);
            }
          `}
          data-testid={suffixTestId('devSettings-button-icon', props)}
        >
          <Icon size={props.iconSize === 'large' ? 5 : 4} value="action/build" cursor="pointer" />
        </div>
      </Center>
    </Clickable>
  );
}
